function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#818181"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.502 7.701v.784c0 .432-.434.785-.965.785H5.784l.002-1.57-3.856 2.352 3.857 2.351-.002-1.566h6.753c1.596 0 2.894-1.056 2.894-2.351v-.785h-1.93z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.929 6.918c0-.433.433-.784.964-.784h6.75v1.567l3.855-2.35L9.645 3v1.567h-6.75C1.297 4.567 0 5.62 0 6.917v.784h1.929v-.783z"
}));

const SvgMoveNodes = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoveNodes, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/move-nodes.ca0862ff.svg";
export { ForwardRef as ReactComponent };